import Phaser from 'phaser'
import Config from '../launch/config'
// import Matter from 'matter-js'
// import MatterAttractors from 'matter-attractors'
// // Matter.use('matter-attractors')
// // Matter.use(MatterAttractors)

export default function formation() {
    const body = this.sprite.body
    // const id = this.chance.guid()
    // Config.shipFormations[id] = {}

    // Draw proximity path
    // this.formationGraphics && this.formationGraphics.clear()
    // this.formationGraphics = Config.scene.add.graphics({
    //     lineStyle: {width: 1, color: 0xaaaaaa},
    // })
    // this.formationCircle = new Phaser.Geom.Circle(
    //     this.x,
    //     this.y,
    //     this.formationRadius
    // )
    // // this.formationGraphics.setDepth(1)
    // this.formationGraphics.moveTo(this.x, this.y)
    // this.formationGraphics.strokeCircleShape(this.formationCircle)

    for (const key in Config.ships) {
        const otherShip = Config.ships[key]

        if (
            this.id === otherShip.id ||
            this.orbitingEntity ||
            otherShip.orbitingEntity
        ) {
            return
        }

        const shipNearAnotherShip = Phaser.Geom.Intersects.CircleToCircle(
            {
                x: this.x,
                y: this.y,
                radius: this.formationRadius,
            },
            {
                x: otherShip.x,
                y: otherShip.y,
                radius: this.formationRadius,
            }
        )

        if (shipNearAnotherShip) {
            const bodyA = body
            const bodyB = otherShip.sprite.body

            let distance = Phaser.Math.Distance.Between(
                bodyA.position.x,
                bodyA.position.y,
                bodyB.position.x,
                bodyB.position.y
            )

            if (!Config.shipFormations[this.id]) {
                Config.shipFormations[this.id] = [this.id, otherShip.id]
                Config.scene.matter.add.constraint(
                    bodyA,
                    bodyB,
                    distance,
                    1 // stiffness
                )
            }
        }
    }
}
